import { ComputeChart } from "./chart";

export default ComputeChart;
